import { defineMessages } from 'react-intl';

export default defineMessages({
    pageTitle: {
        id: 'offer.view.offer-details.Offer Details',
        defaultMessage: 'Offer Details: {offerNumber}',
    },
    currentTab: {
        id: 'offer.view.offer-details.tab.Current',
        defaultMessage: 'Current',
    },
    DownloadIDCard: {
        id: 'offer.view.offer-details.Download ID Card',
        defaultMessage: 'Download ID Card',
    },
    documents: {
        id: 'offer.view.offer-details.Documents',
        defaultMessage: 'Documents',
    },
    paymentCannotProcessed: {
        id: 'offer.view.policy-details.Your Payment Cannot Be Processed At This Time',
        defaultMessage: 'Your Payment Cannot Be Processed At This Time',
    } ,
    pleaseTryAgain: {
        id: 'offer.view.policy-details.Please try again later.',
        defaultMessage: 'Please try again later.',
    },
    errorPolicyHoldUW:{
        id: 'offer.view.policy-details.policy-moratorium.A policy moratorium is in effect for TWIA due to storm activity. No policies will be processed until after the moratorium is lifted.' ,
        defaultMessage: 'A policy moratorium is in effect for TWIA due to storm activity. No policies will be processed until after the moratorium is lifted.'
    },
    cantIssuePolicy: {
        id: 'offer.view.policy-details.policy-blocked.Your policy cannot be issued at this time. Please contact your agent for more information.',
        defaultMessage: 'Your policy cannot be issued at this time. Please contact your agent for more information.'
    },
    noTitle: {
        id: 'offer.view.policy-details.no-title',
        defaultMessage: ''
    }
});
